import React from 'react';
import { Card } from 'antd';

const ChartIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    <path d="M3 3v18h18" />
    <path d="M18 17V9" />
    <path d="M13 17V5" />
    <path d="M8 17v-3" />
  </svg>
);

// Card with an icon + title/subtitle header, used around statistics charts.
// Styles live in assets/css/modern.css (.chart-card).
const ChartCard = ({ title, subtitle, extra, loading, children, className = '', ...rest }) => (
  <Card
    bordered={false}
    loading={loading}
    className={`chart-card ${className}`}
    title={
      <div className="chart-card__head">
        <span className="chart-card__icon">
          <ChartIcon />
        </span>
        <div className="chart-card__titles">
          <div className="chart-card__title">{title}</div>
          {subtitle && <div className="chart-card__subtitle">{subtitle}</div>}
        </div>
      </div>
    }
    extra={extra}
    {...rest}>
    {children}
  </Card>
);

export default ChartCard;
